import CardNews from '@/molecules/CardNews';
import EmptyList from '@/molecules/EmptyList';
import Tile from '@/molecules/Tile';
import { useDateFnsWithLocale } from 'hooks/i18n';
import { useCardHistory } from 'hooks/queries/cards';
import { useTranslation } from 'react-i18next';
import { useCmsData } from 'utils/cms';
import dtoSpecificFields from 'utils/cms/dtoSpecificFields';
import getBadgePropsFromHistory from './HistoryToIcon';
import { FormatAlteredIconsText } from 'utils/formatAlteredText';

const CardHistory = ({ cardRef }: { cardRef: string }) => {
  const {
    queryResult: { data },
  } = useCardHistory({ cardRef });

  const { format } = useDateFnsWithLocale();
  const {
    acf: { widgets },
  } = useCmsData();
  const { t } = useTranslation();
  const {
    rulings_title: title,
    rulings_empty_title: emptyTitle,
    rulings_empty_description: emptyDescription,
    rulings_empty_image: emptyImage,
  } = dtoSpecificFields(widgets);
  const cardHistory = data?.data.cardHistories;

  return (
    <Tile id="history" title={title} withDivider>
      {!cardHistory?.length && <EmptyList options={{ title: emptyTitle, text: emptyDescription, image: emptyImage }} />}
      {!!cardHistory?.length && (
        <div className="flex flex-col gap-2">
          {cardHistory.map((history) => (
            <CardNews
              key={history.id}
              cardBadgeProps={getBadgePropsFromHistory(history.type)}
              title={`${history.name} - ${history.fromDate && format(new Date(history.fromDate), 'LLLL yyyy')}`}
            >
              {history.question && (
                <p>
                  {t('rulings.question')} : <FormatAlteredIconsText>{history.question}</FormatAlteredIconsText>
                </p>
              )}
              {history.answer && (
                <p>
                  {t('rulings.response')} : <FormatAlteredIconsText>{history.answer}</FormatAlteredIconsText>
                </p>
              )}
              {history.description && (
                <p>
                  <FormatAlteredIconsText>{history.description}</FormatAlteredIconsText>
                </p>
              )}
            </CardNews>
          ))}
        </div>
      )}
    </Tile>
  );
};

export default CardHistory;
